<template>
  <VDialog v-model="isVisible" width="750px" persistent attach="#LetsPage">
    <VeeForm ref="observer">
      <VCard v-if="dialogData">
        <VCardTitle>
          {{dialogData?.title}}
        </VCardTitle>
        <VCardText v-debug>
          <h3>dialogData</h3>
          {{dialogData}}
        </VCardText>
        <VCardText class="pt-0">
          <table class="mainDialogTable mt-0">
            <tr>
              <td colspan="2">
                <div v-html="dialogData?.content" />
              </td>
            </tr>
            <LetsAtFormElement
              v-for="(item, index) in [
                { value:'exist_data',
                  type:'textarea',
                  label:$t('C50102.C50102SingleConflictDialog.JRYlxxuG05Z1N4N7A-44O', [moment(dialogData.updated_at).format('YYYY/MM/DD HH:mm:ss')]),
                  props:{ disabled: true, rows: 3 },
                  labelProps:{ style: { width: '150px' } }
                },
                { value:'current_data',
                  type:'textarea',
                  label:$t('C50102.C50102SingleConflictDialog.fh1y2a1zI7k5rbY6qKTMb'),
                  props:{ disabled: true, rows: 3 }
                },
              ]"
              :key="item.value+ index"
              v-model="dialogData[item.value]"
              :item="item"
            />
            <LetsAtFormElement
              v-for="(item, index) in [
                { value:'handover_all_teacher', type:'textarea', label:$t('C50102.C50102SingleConflictDialog.SYYNVIPNPO4LOLoaXSo1n'), props:{ rows: 3 } },
              ]"
              :key="item.value+ index"
              v-model="outputData[item.value]"
              :item="item"
            />
          </table>
        </VCardText>
        <VCardText v-debug>
          <h3>outputData</h3>
          {{outputData}}
        </VCardText>
        <VCardActions>
          <VSpacer></VSpacer>
          <VBtn
            color="primary"
            @click="emitOk"
          >
            {{ $t('C10101.Edit.geng-xin') }} </VBtn>
          <VBtn variant="text" @click="emitCancel">
            {{ $t('common.cancel') }} </VBtn>
        </VCardActions>
      </VCard>
    </VeeForm>
  </VDialog>
</template>

<script>
import DialogMixin from '@/mixins/DialogMixin.js';
import { Form as VeeForm } from 'vee-validate'

export default {
  components:{
    VeeForm
  },
  mixins:[
    DialogMixin
  ],
  data() {
    return {};
  },
  methods: {
    moment: require('moment'),
  }
}
</script>

<style scoped>
span {
  font-size: 1rem
}
.v-card__text{
  font-size: 1rem;
}
.mainDialogTable {
  border-spacing: 5px 10px;
  margin: 10px auto;
  width: 100%;
}
</style>
